import React from 'react'
import { Link } from 'react-router-dom'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import constants from 'app/constants'

import * as orderActions from 'app/actions/order_actions';

class Order extends React.Component{
  constructor(props) {
    super(props);
    this.timeout = null;
    this.state = this.props.order_state.buyer;

  }

  submitOrder(e) {
    e.preventDefault();
    const { sendOrder } = this.props.order_actions;
    if (this.stateIsValid()) {
      sendOrder();
      this.setState({send: true, errors: false});
    } else {
      this.setState({errors: true});
    }
  }

  stateIsValid() {
    return this.state.name.length && this.state.phone.length;
  }

  paramChanged = (name, e) => {
    let
      val = e.target.value,
      _this = this;
    _this.setState({[name]: val, errors: false}, () => {
      clearTimeout(_this.timeout);
      _this.timeout = setTimeout(function() {
        _this.props.order_actions.updateOrderParams(_this.state);
      }, 500)
    });
  };

  renderComplete() {
    return (
      <div>
        <h1>Ваш заказ отправлен</h1>
      </div>
    );
  }

  renderForm() {
    return (
      <div>
        <h1>Заказ сейф двери</h1>
        <div className='form order-form'>
          <div className='help call-'>
            Мы перезвоним вам
            и подтвердим ваш заказ
            в течение 24 часов в будни.
          </div>
          <div className='inputs'>
            <div className='form-part'>
              <div className='label required-'>
                Ваше имя
              </div>
              <div className={`input ${this.state.errors && !this.state.name.length ? 'error-' : ''}`}>
                <input name='name' onChange={this.paramChanged.bind(this, 'name')} placeholder='' value={this.state.name} />
              </div>
            </div>
            <div className='form-part'>
              <div className='label required-'>
                Телефон
              </div>
              <div className={`input phone- ${this.state.errors && !this.state.phone.length ? 'error-' : ''}`}>
                <input className='empty' onChange={this.paramChanged.bind(this, 'phone')} name='phone' placeholder='' value={this.state.phone} />
              </div>
            </div>
            <div className='form-part'>
              <div className='label'>
                Примечание
              </div>
              <div className='input'>
                <textarea placeholder='Укажите адрес доставки и другую важную информацию'
                          value={this.state.comment}
                          onChange={this.paramChanged.bind(this, 'comment')}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="mobile-show">
          <Link className='back-link' to={constants.ROUTES.STEP5}>Назад к доп. опциям</Link>
        </div>
        <a className='button button-red button-large wizard-next-action-button' onClick={this.submitOrder.bind(this)} href='#'>
          <span>Заказать</span>
        </a>
      </div>
    );
  }

  render() {
    return this.state.send ? (this.renderComplete()) : (this.renderForm())
  }
}

const mapStateToProps = (state) => {
  return {
    order_state: state.orderState,
    app: state.applicationState,
  }
};

const mapDispatch = (dispatch) => {
  return {
    order_actions: bindActionCreators(orderActions, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatch, null, {pure: false})(Order);



// WEBPACK FOOTER //
// ./app/javascript/app/pages/order/index.jsx